import { useCallback, useMemo } from 'react';
import * as Yup from 'yup';

export const useYearsOfExperienceFilter = ({ setFilters }) => {
  const formSchema = useMemo(
    () =>
      Yup.object().shape({
        yearsOfExperience: Yup.object().nullable(),
      }),
    [],
  );

  const onSubmit = useCallback(
    (values) => {
      const rangeValues = values.yearsOfExperience;
      const filterValue = rangeValues
        ? {
            years_experience_gteq: rangeValues.min,
            years_experience_lteq: rangeValues.max,
          }
        : null;

      setFilters({ yearsOfExperience: filterValue });
    },
    [setFilters],
  );

  return {
    formSchema,
    onSubmit,
  };
};
